import { Component, Input } from '@angular/core';
import { AgreementStatus } from '../../../entity/domain/models/entity.model';
import { IdentityNavigationService } from '../../../identity-verification/services/identity-navigation.service';
import { MsaAgreementMessages } from '../../const/data/dashboard-data';

@Component({
    selector: 'ifm-review-msa-agreement',
    templateUrl: './review-msa-agreement.component.html',
    styleUrls: ['./review-msa-agreement.component.scss'],
    standalone: false
})
export class ReviewMsaAgreementComponent {
  @Input() applicationId: number;
  @Input() msaAgreementStatus: AgreementStatus;

  readonly AgreementStatus = AgreementStatus;
  readonly MsaAgreementMessages = MsaAgreementMessages;

  constructor(private identityNavigationService: IdentityNavigationService) { }

  reviewMsaAgreement() {
    this.identityNavigationService.signApplicationAgreement({ applicationId: this.applicationId })
  }
}
